import React from 'react'
import { Form } from 'react-bootstrap'
import { setWorkers } from '../Redux/companyReducer';
import { useDispatch } from 'react-redux';
import { useTranslation } from '../hooks/useTranslation';

function SendTo({ paymentStep, setSendToWorkes }) {
    const { t, tHtml } = useTranslation();
    const dispatch = useDispatch();

    return (
        <Form>
            {['radio'].map((type) => (
                <div key={`reverse-${type}`} className="mb-4">
                    <Form.Check
                        reverse
                        label={t("ToMe")}
                        defaultChecked
                        disabled={paymentStep}
                        name="group1"
                        type={type}
                        id={`reverse-${type}-1`}
                        onClick={() => {
                            setSendToWorkes(false)
                            dispatch(setWorkers([]))
                        }}
                    />
                    <Form.Check
                        reverse
                        label={tHtml("ChooseRecipients")}
                        name="group1"
                        disabled={paymentStep}
                        type={type}
                        id={`reverse-${type}-2`}
                        onClick={() => setSendToWorkes(true)}
                    />
                </div>
            ))}
        </Form>
    )
}

export default SendTo